var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.4995V9.99951H2.5C1.1225 9.99951 0 11.122 0 12.4995V17.4995H18.0275C17.68 15.972 17.5 14.327 17.5 12.4995Z",
    fill: "#009999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8975 22.4995C38.1925 25.127 35.5925 27.362 31.8675 29.502C31.295 29.8295 30.65 29.9995 30 29.9995C29.35 29.9995 28.705 29.8295 28.14 29.507C24.415 27.362 21.815 25.1245 20.1075 22.4995H0V34.9995C0 36.3795 1.1225 37.4995 2.5 37.4995H37.5C38.88 37.4995 40 36.3795 40 34.9995V22.4995H39.8975ZM11.25 29.9995H6.25C5.56 29.9995 5 29.4395 5 28.7495C5 28.0595 5.56 27.4995 6.25 27.4995H11.25C11.94 27.4995 12.5 28.0595 12.5 28.7495C12.5 29.4395 11.94 29.9995 11.25 29.9995Z",
    fill: "#009999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2425 6.35174L30.4925 2.60174C30.175 2.46674 29.8225 2.46674 29.505 2.60174L20.755 6.35174C20.2975 6.54674 20 6.99924 20 7.49924V12.4992C20 19.3767 22.5425 23.3967 29.3775 27.3342C29.57 27.4442 29.785 27.4992 30 27.4992C30.215 27.4992 30.43 27.4442 30.6225 27.3342C37.4575 23.4067 40 19.3867 40 12.4992V7.49924C40 6.99924 39.7025 6.54674 39.2425 6.35174ZM34.7275 12.0317L29.7275 18.2817C29.4875 18.5767 29.1275 18.7492 28.75 18.7492C28.7325 18.7492 28.7125 18.7492 28.6975 18.7492C28.3 18.7317 27.9325 18.5267 27.71 18.1942L25.21 14.4442C24.8275 13.8692 24.9825 13.0942 25.5575 12.7117C26.1275 12.3317 26.905 12.4817 27.29 13.0592L28.8425 15.3867L32.7725 10.4717C33.205 9.93424 33.9925 9.84924 34.53 10.2767C35.07 10.7042 35.155 11.4917 34.7275 12.0317Z",
    fill: "#009999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.363f724d37b989e5e992dbff7637ab4b.svg";
export { ForwardRef as ReactComponent };